'use client'

import {observer} from 'mobx-react'

import * as UI from '@/src/(pages)/catalog/screen.styled'
import {CatalogContent, CatalogProductListContent} from '@/src/core/domain/entities/catalog'
import {PageType} from '@/src/core/domain/entities/page'
import {CatalogFiltersMobileBtn} from '@/src/features/catalog/filters-v2/ui/mobile-filters-btn'
import {useStore} from '@/src/shared/hooks/useStore'
import {LayoutMeta} from '@/src/shared/ui/layout/ui/meta'
import {PageTitle} from '@/src/shared/ui/layout/ui/page-title'
import {LayoutUI} from '@/src/shared/ui/layout/ui/styles'

export const CatalogMeta = observer(() => {
  const store = useStore<CatalogContent | CatalogProductListContent>()

  if (!store.pageData) return null
  const pageData = store.pageData

  let title: string = ''

  if (pageData.type === PageType.CatalogRoot) {
    title = 'Каталог'
  } else if (pageData.type === PageType.CatalogProductList && 'section' in pageData.content) {
    title = (pageData.content as CatalogProductListContent).section.name
  } else if (pageData.type === PageType.CatalogSales) {
    title = 'Sale'
  }
  const catalogPageTypes = [PageType.CatalogProductList, PageType.BrandProductList, PageType.CatalogSales]

  return (
    <LayoutUI.Meta
      as={LayoutMeta}
      title={
        <PageTitle>
          {title && <h1>{title}</h1>}
          {pageData.type && catalogPageTypes.includes(pageData!.type as ArrayItem<typeof catalogPageTypes>) && (
            <UI.CatalogFiltersMobileBtn as={CatalogFiltersMobileBtn} />
          )}
        </PageTitle>
      }
      breadcrumbs={pageData.breadcrumbs}
    />
  )
})
